import React, { PropTypes, PureComponent } from 'react';

export default class FieldValue extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      name: PropTypes.string.isRequired,
      colorStyles: PropTypes.object.isRequired
    }).isRequired
  };

  render() {
    const {
      value: { name, colorStyles: { borderColor, color, backgroundColor } = {}, field: { style: fieldStyle } },
      style, ...rest
    } = this.props;

    return (
      <span
        title={name}
        style={{
          ...(
            fieldStyle !== 'PLAIN' ?
            {
              display: 'inline-block',
              fontSize: 12,
              verticalAlign: 'middle',
              borderWidth: 1,
              borderStyle: 'solid',
              borderRadius: 4,
              padding: '0.05em 0.4em',
              borderColor: borderColor || 'transparent',
              color,
              backgroundColor
            } :
              null
          ),
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          maxWidth: '100%',
          textOverflow: 'ellipsis',
          margin: 0,
          ...style
        }} {...rest}>
        {name}
      </span>
    );
  }
}

export const ShortFieldValue = ({ style, ...rest }) => <FieldValue style={{ maxWidth: 60, ...style }} {...rest}/>;


// WEBPACK FOOTER //
// ./src/js/components/layout/FieldValue.jsx